import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { APIResult } from "models/api-results";


import { DashboardSummaryResult } from "../../models/reports/dashboard-summary";


export async function GetDashboardSummary(): Promise<APIResult<DashboardSummaryResult>> {
    const apiUrl = `${ApiEndPoints.dashboard_summary}`;
    return await WebAPIClient.getData<DashboardSummaryResult>(apiUrl);
}